import { useAppMessageSender } from "@albertine/wrapper-interop/react";
import {
    parentOriginFromLocation,
    postMessageToParentFrame,
} from "../../lib/parentFrame";

export function useNavigateBack() {
    const sendAppMessage = useAppMessageSender();

    return function handleBack() {
        const parentOrigin = parentOriginFromLocation();

        if (parentOrigin && window.parent !== window) {
            postMessageToParentFrame(parentOrigin, { type: "navigateBack" });
            return;
        }

        sendAppMessage("navigateBack");
    };
}
